import { useEffect, useState } from 'react';
import { YField, YSelect } from '../../../../components/yool/YoolPrimitives';
import { getPlanes } from '../../../../services/divinaPlanesService';

export default function PasoPlan({ productoId, value, onChange }) {
  const [planes, setPlanes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    getPlanes()
      .then((data) => { if (!ignore) setPlanes(data); })
      .catch((error) => console.warn('Error al obtener planes:', error))
      .finally(() => { if (!ignore) setLoading(false); });
    return () => { ignore = true; };
  }, []);

  if (!productoId) {
    return <p className="y-field-hint">Selecciona un producto primero.</p>;
  }

  // Una póliza colectiva solo puede referenciar planes con tipo_emision =
  // 'colectiva' y activos — la DB rechaza el insert si no (regla real,
  // confirmada en producción). Filtrar aquí evita que el usuario elija un
  // plan individual/inactivo y recién se entere del rechazo al guardar
  // en el paso 5.
  const disponibles = planes.filter(
    (p) => String(p.producto?.id) === String(productoId) && p.tipo_emision === 'colectiva' && p.activo
  );

  return (
    <YField
      label="Plan"
      required
      hint={disponibles.length === 0 ? 'Este producto no tiene planes colectivos — créalo desde Product Config → Planes (tipo_emision = colectiva) y vuelve a este paso.' : undefined}
    >
      <YSelect
        data-testid="select-plan"
        value={value?.plan_id || ''}
        onChange={(e) => onChange({ plan_id: e.target.value })}
        disabled={loading}
      >
        <option value="">{loading ? 'Cargando...' : 'Selecciona plan'}</option>
        {disponibles.map((p) => (
          <option key={p.id} value={p.id}>{p.nombre}</option>
        ))}
      </YSelect>
    </YField>
  );
}
